const file = {
    'File.CannotDownloadThisFile': "Sorry you can't download {0} at this time. Please try again later.",
    'File.CannotViewinBrowser': "You cannot view this file in the browser",
    'File.Download': "Download",
    'File.Downloaded': "Downloaded",
    'File.Downloading': "Downloading",
    'File.File': "File",
    'File.FileIcon': 'File Icon',
    'File.NoFileFound': "We could not find this file in your Locker",
    'File.NoFileFoundExplanatory': "The file may have been deleted. If you should have access to this file, please contact a Locker administrator",
    'File.OpenFile': "Open file",
    'File.SaveFileToDevice': "Save file to device",
    'File.UploadingFilesPlural': 'Uploading {0} files',
    'File.UploadingFilesSingular': 'Uploading 1 file',
    'File.UploadProgressMultiple': '{0}/{1} complete {2}',
    'File.FinishingUp': 'Finishing Up'
}

const General = {
    'General.Address': "Address",
    'General.AccessNotGranted' : "You do not have permission to access this page.",
    'General.AcknowledgementCompetitionFull': "Acknowledgement competition full",
    'General.AcknowledgementCompetitionUnspecified': "Acknowledgement competition unspecified",
    'General.AcknowledgementEventFull': "Acknowledgement event full",
    'General.AcknowledgementEventUnspecified': "Acknowledgement event unspecified",
    'General.AcknowledgementNoPermission': "You do not have permission to respond",
    'General.AcknowledgementNoPermissionContactAdmin': "You do not have permission to respond to this content, please contact an admin for information",
    'General.AreYouSure': "Are you sure?",
    "General.BackToAppLibrary": "Back to App Library",
    'General.Call': "Call",
    'General.Cancel': "Cancel",
    'General.ContactSupport': "Contact Support",
    'General.ContentPreviewForX': 'Content preview image for {0}',
    'General.ContentPreviewMissingForX' : 'Content preview image missing for {0}',
    'General.ContentPreviewVideoForX' : 'Content preview video for {0}',
    'General.Department': "Department",
    'General.Edit':"Edit",
    'General.Email': "Email",
    'General.EmailAddress': "Email address",
    'General.EmailSent': "We’ve sent you an email",
    'General.EnterThisCompetition': "Enter this competition",
    'General.ExternalAuthProviderFailure': "Sorry, an unexpected error occurred contacting your external login provider. Please try again.",
    'General.ExternalAuthProviderRedirectMessage': "Please wait...Redirecting you to your external login provider ",
    'General.FilterDate': "Filter by Date",
    'General.GoThereNow': "Go there now",
    'General.Input': 'Input',
    'General.InvalidPasswordEntry': "Invalid Password, please try again",
    'General.LockerBreadcrumb': "Return to my Locker",
    'General.LinkCopied' : "Link has been copied to clipboard.",
    'General.MarkedAsCompleted': "Marked as Completed",
    'General.MainMenu': 'Main Menu',
    'General.Mobile': "Mobile number",
    'General.Name' : "Name",
    'General.Next': "Next",
    'General.NoCancel': "No, Cancel",
    'General.NoInternetConnection': "No internet connection",
    'General.Ok': "OK",
    'General.OpenMenu': 'Open Menu',
    'General.Password': "Password",
    'General.PageNotFound' : "Page not found.",
    'General.PageNotFoundDetails' : "The page you are looking for may have been removed or is temporarily unavailable.",
    'General.PostMarkedAsCompleted': "Post marked as completed",
    'General.RSVPToThisEvent': "RSVP to this event",
    'General.RefreshTokenExpiry': "Your Locker session has expired. To continue using Locker, please re-enter your Locker passcode",
    'General.Remove': "Remove",
    'General.SelectAWorkspace': "Select a workspace",
    'General.SelectCountryCode': "Select Country Code",
    'General.Settings': "Settings",
    'General.ShareThisPost' : "Share this post",
    'General.SomethingWentWrong': "Something went wrong",
    'General.Telephone': "Telephone",
    'General.TheCompetitionIsNowClosed': "The competition is now closed",
    'General.ThisEventIsNowClosed': "This event is now closed",
    'General.ThisEventIsNowFull': "This event is now full",
    'General.ThisPostNeedsYourAttention': "This post needs your attention",
    'General.ToContent': "Take me to the content",
    'General.Undo': "Undo",
    'General.UnexpectedError': "Sorry, an unexpected error occurred. Please try again.",
    'General.Username': "Username",
    'General.Website': "Website",
    'General.YesDelete': "Yes, Delete",
    'General.YoureGoingToThisEvent': "You're going to this event",
    'General.YouveEnteredThisCompetition': "You've entered this competition",
    'General.ViewInNewWindow' : "Please click here to view content in new window",
    'General.ViewContent': "View content",
    'General.Save': 'Save',
    'General.Post': 'Post',
    'General.Back': "Back",
    'General.ReturnToPrevious': "Click to return to previous content",

    /* PB */
    'General.Locker': "Locker",
    'General.PeopleDirectory': "People directory",
    'General.Notifications': "Notifications",
    'General.Profile': "Profile",
    'General.AppLibrary': "App library",
    'General.Logout': "Logout",
    'General.MorePeople': "{0} more people",
    'General.ViewPost': "View Post",
    'General.ViewList': "View List",
    'General.ViewWebpage': "View Webpage",
    'General.ViewImage': "View Image",
    'General.WatchVideo': "Watch Video",
    'General.OpenDocument': "Open Document",
    'General.ViewContact': "View Contact",
    'General.ViewRss': "View RSS",
    'General.PlayAudio': "Play Audio",
    'General.XPeople': "{0} people",
    'General.XSelected': "{0} selected",
    'General.LikedBy' : "Liked by",
    'General.PhoneNumberRemoved': 'Phone number removed',
    'General.PasswordsDoNotMatch': 'Passwords do not match.',
    'General.PasswordCriteria': 'Passwords must have at least one special character. Passwords must have at least one digit (\'0\'-\'9\'). Passwords must have at least one uppercase (\'A\'-\'Z\'). Passwords must be more than 8 characters long',
    'General.PasswordShouldContain': 'Should contain a minimum of 8 characters, at least one uppercase letter, one number and one symbol',
    "General.SaveChanges":"Save Changes",

    // recog
    'General.MinimumCharacters': 'Enter a minimum of {0} characters',
    'General.MaximumCharacters': 'You can enter a maximum of {0} characters',
    'General.Required': 'Required',
    'General.MustBeNumeric': 'Must be numeric',
    'General.TextOnly': 'Text only',
    'General.EmailInvalid': 'Email invalid',
    'General.SelectAnOption': 'Select an option',
    'General.EnterSomeText': 'Enter some text',
    'General.OptionalImageCaption': 'OPTIONAL IMAGE CAPTION',
    'General.AddImageCaption': 'Add your image caption',
    'General.AddImage': 'Add Image',
    'General.AddFile': 'Add File',
    'General.Date': 'Date',
    'General.Filter': 'Filter',
    'General.Yes': 'Yes',
    'General.No': 'No',
    'General.AllDay': 'All Day',

    // search
    'General.Search': 'Search',
    'General.ClearFilters': 'Clear Filters',
    'General.SaveSettings': 'Save Settings',
    'General.ShowResults': 'Show Results',

    // Notifications
    'General.MarkAllAsRead': 'Mark all as read',
    'General.AllCaughtUp': 'All caught up',
    'General.MarkAllNotificationsAsRead' : 'Mark all notifications as read?',
    'General.UnreadNotifications' : 'Unread Notifications',
    'General.UnreadNotificationsCount' : '{0} Unread Notifications',
    'General.WorkspaceLoginPageTitle': 'Organisation Login | Thrive Employee Communications',
    'General.LoginPageTitle': 'Login | {0}',
    'General.ForgotPasswordPageTitle': 'Forgot Password | {0}',
    'General.RegistrationPageTitle': 'Registration | {0}',
    'General.RegisterNewPasswordPageTitle': 'Create a New Password Page',

    //sharing socials
    'General.ShareOnFacebook' : 'Share on Facebook',
    'General.ShareOnX' : 'Share on X',
    'General.LinkedIn' : 'Share on LinkedIn',
    'General.CopyLinkToShare' : 'Copy the link to share',
    'General.ViewShareMenu' : 'Click to view sharing options',
    'General.CloseMenu' : 'Click to close menu',

    //hero
    'General.ToggleCarouselItem': 'Toggle to Carousel Item',
    'General.PreviousCarousel': 'Previous Carousel Item',
    'General.NextCarousel': 'Next Carousel Item',
    'General.StartCarousel': 'Start Carousel',
    'General.PauseCarousel': 'Pause Carousel',
    'General.DownloadVideo': 'Download Video',
    'General.XOfX' : "{0} of {1}",

    //a11y
    'General.SkipToContentOnThisPage': 'Skip to content on this page',
    'General.WorkspaceLogo': 'Organisation Logo',
    'General.CloseModal': 'close modal',
    'General.SkipToTop': 'Skip to Top',
    'General.XAutoCompleteSuggestions': 'There are {0} suggestions. Use the up and down arrows to browse.',

    'General.DownloadContact': 'Download Contact',
    'General.ClearSearch': 'Clear Search',
    'General.ViewXUsersProfile': 'View {0}’s profile',

    'General.About': 'About',
    'General.PrivacyPolicy': 'Privacy Policy',
    'General.ThisLinkOpensInANewTab': 'This link opens in a new tab',

    //chat
    "General.Chat": "Chat",
    "General.Preview": "Preview",
    "General.You": "You"
}

const Locker = {
    'Locker.ANewFile' : "A new file has been put in your Locker. Open your Locker to access it",
    'Locker.All': "All",
    'Locker.AltTextNoFiles' : 'Magnifying Glass',
    'Locker.AltTextNewUser': "Padlock with smiling face.",
    'Locker.AltTextUserRegistrationComplete': "Padlock with smiling face and confetti.",
    'Locker.AltTextLockerIcons': "Powerpoint icon, Word document icon, and video icon.",
    'Locker.Cancel': "Cancel",
    'Locker.Clear': "Clear",
    'Locker.ClearAll': "Clear All",
    'Locker.Close': "Close",
    'Locker.Confirm': "Confirm",
    'Locker.CreatePasscode': "Create a passcode",
    'Locker.Done': "Done",
    'Locker.EmptyLocker': "Your Locker is empty",
    'Locker.EmptyLockerExplanatory': "Don’t worry, this just means your admin hasn’t uploaded anything yet. Check back later!",
    'Locker.EnableBiometrics': "Enable Biometrics Authentication",
    'Locker.EnableBiometricsExplanatory': "Enabling Biometrics allows you quick and secure access to your locker files.",
    'Locker.EnterPassword': "Enter your password",
    'Locker.EnterYourPasscode': "Enter your passcode",
    'Locker.EnterPasswordExplanatory': "To ensure that your Locker is kept secure, this extra level of security is required",
    'Locker.FileHasBeenPutInLocker': "{0} has been put in your Locker. Open your Locker to access it",
    'Locker.FilterExplanatoryTime': "Please note: the filter(s) selected will display items uploaded within the chosen time periods(s)",
    'Locker.FilterExplanatoryType': "Please note: the filter(s) selected will display items uploaded with the chosen file type(s)",
    'Locker.ForgotPasscode': "Forgotten Passcode",
    'Locker.ForgotPasscodeQuestion': "Forgotten your passcode?",
    'Locker.GetStarted': "Get Started",
    'Locker.GoodAfternoon': "Good Afternoon",
    'Locker.GoodEvening': "Good Evening",
    'Locker.GoodMorning': "Good Morning",
    'Locker.Icon' : "Icon",
    'Locker.IncorrectPasscode': "Incorrect passcode",
    'Locker.Locker': "Locker",
    'Locker.LockerIsReady': "Your Locker is ready!",
    'Locker.LockerIsReadyExplanatory': "Now you can view & download documents directly from your Locker.",
    'Locker.MonthFilter': "Month",
    'Locker.MyLocker': "My Locker",
    'Locker.NetworkError': "Network Error",
    'Locker.NoResults': "No results for",
    'Locker.Offline': "Unable to access your Locker, no internet connection.",
    'Locker.OpenMyLocker': "Open my Locker",
    'Locker.PasscodeDoesNotMatch': "Passcode does not match",
    'Locker.PasscodeResetUnavailable': "Passcode Reset Unavailable",
    'Locker.PasscodeResetUnavailableExplanatory': "We have noticed your account password was changed recently. For security we cannot process this request at this time. Please try again later or contact your organisation admin for more information",
    'Locker.PasscodeSetup': "Locker passcode set-up complete",
    'Locker.PasscodeTooManyTimes': "You have entered your passcode incorrectly too many times. Please wait {0} and try again",
    'Locker.Password': "Password",
    'Locker.PasswordExplanatory': "This is your account password that you use to login to the app",
    'Locker.ReEnterPasscode': "Re-enter your passcode",
    'Locker.ReEnterPasscodeToConfirm': "Re-enter your passcode to confirm",
    'Locker.ResetFilters': "Reset Filters",
    'Locker.ResetRequestSentExplanatory': "You’ve successfully sent a reset request. Once an admin has approved this you can reset your passcode. Please check back later",
    'Locker.ResetRequestSent': "Reset Request Sent",
    'Locker.Search': "Search",
    'Locker.SearchPlaceholder': "Search by filename",
    'Locker.SendResetRequest': "Send Reset Request",
    'Locker.SendResetRequestExplanatory': "To reset your passcode you must send a reset request to an admin",
    'Locker.SetupIsReady': "Your Locker is ready to be setup!",
    'Locker.ShowFiles': "Show {0} files",
    'Locker.ShowingResults': "Showing Results for {0}",
    'Locker.SignInWithBiometrics': "Locker Biometrics Sign In",
    'Locker.SigninWithBiometricesExplanatory': "Enabling Biometrics allows you quick and secure access to your locker files.",
    'Locker.TypeFilter': "Type",
    'Locker.Update': "Update",
    'Locker.View': "View",
    'Locker.Welcome': "Welcome",
    'Locker.WelcomeExplanatory': "You can view and download important documents straight from your Locker. But first, please set up a passcode to keep your Locker secure…",
    'Locker.YearFilter': "Year", 
    'General.XSelected': '{0} selected',
    'Locker.CreatePasscodeExplanatory': 'Create a passcode for your Locker',
    'LockerUnavailableExplanatory': 'Unfortunately we could not reach locker at this time. Please try again later.',
    'LockerUnavailable': 'Locker is temporarily unavailable',
    'Locker.SetupUnavailableTitle': 'Locker Setup is Unavailable',
    'Locker.SetupUnavailable': 'We have noticed that your account password was changed recently. For security we cannot allow you to setup locker at this time. Please try again later.',
    'Locker.ExitLocker': 'Exit Locker',
    'Locker.LockedOut': 'You are currently locked out. You can set up Locker again in {0}',
    'Locker.GettingCredentials': 'Checking for Locker credentials'
}

const Month = {
    'Month.April': "April",
    'Month.August': "August",
    'Month.December': "December",
    'Month.February': "February",
    'Month.January': "January",
    'Month.July': "July",
    'Month.June': "June",
    'Month.March': "March",
    'Month.May': "May",
    'Month.November': "November",
    'Month.October': "October",
    'Month.September': "September",

    'Month.Jan': 'Jan',
    'Month.Feb': 'Feb',
    'Month.Mar': 'Mar',
    'Month.Apr': 'Apr',
    'Month.Jun': 'Jun',
    'Month.Jul': 'Jul',
    'Month.Aug': 'Aug',
    'Month.Sep': 'Sep',
    'Month.Oct': 'Oct',
    'Month.Nov': 'Nov',
    'Month.Dec': 'Dec'
}

const date = {
    'Date.JustNow': 'just now',
    'Date.Now': "now",
    'Date.Sec': "sec",
    'Date.Min': "min",
    'Date.Mins': "mins",
    'Date.Hour': "hour",
    'Date.Hours': 'hours',
    'Date.Day': 'day',
    'Date.Days': "days",
    'Date.Month': "month",
    'Date.Months': "months",
    'Date.Year': "year",
    'Date.Years': "years",
    'Date.Week': 'week',
    'Date.Weeks': 'weeks',
}

const Onboarding = {
    'Onboarding.': "Choose Recovery Option",
    'Onboarding.AddMobile': "Add mobile number",
    'Onboarding.AgreeTermsOfUse': "I agree to the [button]{0}[/button]",
    'Onboarding.AgreeTo': "I agree to the",
    'Onboarding.AlreadyCompletedRegistration': "Already completed registration?",
    'Onboarding.AlreadyRegistered': "You have already registered, please login instead",
    'Onboarding.BackToLogin': "Back to Login",
    'Onboarding.BackToRecovery': "Back to Recovery Options",
    'Onboarding.BackToRegistration': "Back to Registration",
    'Onboarding.BackToWorkspaceSelection': "Go back to organisation log in",
    'Onboarding.BrandLogo': "Brand Logo",
    'Onboarding.ChangeWorkspace': "Change workspace",
    'Onboarding.ChangeYourPassword': "Change your password",
    'Onboarding.ChooseNewPassword': "Choose a new password",
    'Onboarding.ChooseRecoveryMethod': "Choose recovery method",
    'Onboarding.ClickLinkInEmail': "Tap the link in the email we have just sent you to reset your password",
    'Onboarding.CompleteRegistration': "Before you can login, you must complete the registration process",
    'Onboarding.ConfirmNewPassword': "Confirm New Password",
    'Onboarding.ContactSupportPassword': "You’ll need to contact your organisation’s support team to reset your password",
    'Onboarding.CreateWorkspace': "Learn more about Thrive",
    'Onboarding.CurrentPassword': "Current Password",
    'Onboarding.CurrentPasswordIncorrect': "Your current password is incorrect",
    'Onboarding.DetailsNotShared': "Don’t worry yenter the code we sent our contact details aren’t shared with your organisation",
    'Onboarding.DoThisLater': "Do this later",
    'Onboarding.EnterCode': "Enter Code",
    'Onboarding.EnterCodeSentViaText': "Enter the code we sent to you via text",
    'Onboarding.EnterCurrentPassword': "Enter Current Password",
    'Onboarding.EnterNewPassword': "Choose New Password",
    'Onboarding.EnterOrgPassword': "Please enter the username and password provided by your organisation to start using the app.",
    'Onboarding.EnterPasswordToReset': "Enter your username to reset your password",
    'Onboarding.EnterTempPassword': "Enter the username and temporary password your organisation has provided you to allow you to start using the app",
    'Onboarding.EnterValidEmail': "Please provide a valid email address",
    'Onboarding.EnterValidPhone': "Please provide a valid phone number",
    'Onboarding.EnterWorkspaceName': "Enter the organisation name you were provided",
    'Onboarding.ErrorExternalProvider': "Oops! There was an issue getting external provider details",
    'Onboarding.ForgetPasswordReset': "If you forget your password we’ll send a reset link to you via email or text",
    'Onboarding.ForgotPassword': "Forgot Password",
    'Onboarding.GetStarted': "Get Started",
    'Onboarding.HaventSetupWorkspace': "Haven’t set up a workspace yet?",
    'Onboarding.IncorrectCode': "Incorrect code",
    'Onboarding.IssueAutoLogin': "Oops! There was an issue automatically logging you in.",
    'Onboarding.LockedOut': "You have been locked out of your account for {0}",
    'Onboarding.LockedOut5Minutes': "You have been locked out of your account for 5 minutes",
    'Onboarding.LogInToYourWorkspace': "Where do you work?",
    'Onboarding.LogInWith': "LOG IN WITH",
    'Onboarding.Login': "Login",
    'Onboarding.LoginFailed': "Login failed",
    'Onboarding.LoginToYourAccount': "Log in to your account to view your app ",
    'Onboarding.MobileNumberRemoved': "Mobile Number Removed",
    'Onboarding.MobileNumberUpdated': "Mobile Number Updated",
    'Onboarding.NeedToRegister': "Need to Register?",
    'Onboarding.NewHereGetStarted': "It looks like you are new here!",
    'Onboarding.NewPassword': "New Password",
    'Onboarding.NoRecoverySetup': "You have no password recovery method set up",
    'Onboarding.OrgWontSeeDetails': "Your organisation won't have access to this information, and it's never shared with any third party. It's solely utilised for password recovery purposes.",
    'Onboarding.OrganisationWontSeeNotShared': "Don’t worry, your Organisation won’t see this and this isn’t shared with any third party - this is only used for password recovery",
    'Onboarding.OrganisationInputInformation': "Ask your manager or colleagues if you are not sure.",
    'Onboarding.PasswordCriteria': "Passwords should be at least 8 characters, including both uppercase and lowercase letters, a number, and a special character.",
    'Onboarding.PasswordNotEmpty': "Password cannot be empty",
    'Onboarding.PasswordRecoveryRemoved': "Password recovery method removed",
    'Onboarding.PasswordSameAsOld': "The new password must be different to the previous one.",
    'Onboarding.PasswordSentReminder': "If you forget your password we’ll send a reset link to you via email or text",
    'Onboarding.PasswordSentReminderSms': "If you ever forget your password, we'll send you a reset link via text message.",
    'Onboarding.PasswordsDontMatch': "Passwords don’t match",
    'Onboarding.PhoneAlreadyAssociated': "This phone number is already associated with your account",
    'Onboarding.PickNewPassword': "To keep your account secure, please pick a new password.",
    'Onboarding.PleaseEnterWorkspace': "Please enter your organisation name",
    'Onboarding.PleaseUpdate': "The app is outdated. Please update it to the latest version.",
    'Onboarding.PopupRequiredLogin': "A Popup is required to login to this site. Please ensure Popups are enabled, then refresh the page to continue logging in.",
    'Onboarding.RegisterGetStarted': "Need to Register? [button]Get Started[/button]",
    'Onboarding.RegisterWithOrg': "Register with {0}",
    'Onboarding.RegisterYourAccount': "Register Your Account",
    'Onboarding.RegistrationSuccessful': "Your registration was successful",
    'Onboarding.RemoveEmail': "Remove email address",
    'Onboarding.RemoveMobile': "Remove mobile number",
    'Onboarding.RemoveRecovery': "Remove Recovery Method",
    'Onboarding.RemoveRecoveryConfirm': "Are you sure you want to remove this recovery method?",
    'Onboarding.RepeatPassword': "Confirm password",
    'Onboarding.ResendEmailVerification': "Resend verification email",
    'Onboarding.ResendMobileVerification': "Resend code to mobile",
    'Onboarding.ResetLinkSent': "Reset link sent",
    'Onboarding.ResetPassword': "Reset your password",
    'Onboarding.ResetPasswordSelect': "Tell us if you’d like us to send your password reset link to your email address or mobile number",
    'Onboarding.SendMeEmail': "Send me an Email",
    'Onboarding.SendMeText': "Send me a Text",
    'Onboarding.SetPasswordRecovery': "Set Password Recovery",
    'Onboarding.SetupWorkspace': "Haven’t set up a workspace yet?",
    'Onboarding.StartExploring': "Start Exploring",
    'Onboarding.TempPassword': "Temporary password",
    'Onboarding.TextMessageLinkWeSentYou': "Tap the link in the text message we have just sent you to reset your password",
    'Onboarding.TsAndCs': "Terms & Conditions",
    'Onboarding.TermsOfUse': "terms of use",
    'Onboarding.UnableToCompleteRegistration': "We haven't been able to complete your registration, please try again",
    'Onboarding.UpdateMobile': "Update mobile number",
    'Onboarding.UpdateMobileNumber': "Update your mobile number",
    'Onboarding.UpdatePasswordRecovery': "Update Password Recovery",
    'Onboarding.UpdateRequired': "Update required",
    'Onboarding.UserNotFound': "Username not recognised",
    'Onboarding.UserOrPasswordIncorrect': "Your username or password is incorrect",
    'Onboarding.UsernameNotEmpty': "Username cannot be empty",
    'Onboarding.VerifyEmail': "To verify your email address tap the link in the email we’ve just sent you",
    'Onboarding.VerifyEmailFailed': "Email verification failed",
    'Onboarding.VerifyEmailFailedMessage': "Something went wrong. Please click the link below to resume the registration process.",
    'Onboarding.VerifyEmailSuccess': "Email verification successful",
    'Onboarding.VerifyEmailSuccessMessage': "Your email address was successfully verified. You may now log in through the link below.",
    'Onboarding.WhatEmail': "What’s your email address?",
    'Onboarding.WhatPhone': "What’s your mobile number?",
    'Onboarding.WorkspaceName': "Organisation",
    'Onboarding.WorkspaceUnrecognised': "Sorry, we don’t recognise that organisation name",
    'Onboarding.YourWorkspaceName': "OrganisationName - No Spaces",
    'Onboarding.YoureIn': "You're in!",
    "Onboarding.PasswordChangeSuccess":"Password successfully changed"
}
    
    
const People = {
    'PeopleDirectory.BackToDirectory': "Back to Directory",
    'PeopleDirectory.DownloadContact': "Download Contact",
    'PeopleDirectory.NoResultsForX': "No results found for \"{0}\"",
    'PeopleDirectory.NobodyFound': "Nobody found",
    'PeopleDirectory.People': "People",
    'PeopleDirectory.SearchForNameJob': "Search for a name or job role",
    'PeopleDirectory.See1Result': "See 1 result",
    'PeopleDirectory.SeeXResults': "See all {0} results",
    'PeopleDirectory.ShowingResultFor': "Showing 1 result for \"{0}\"",
    'PeopleDirectory.ShowingXResultsFor': "Showing {0} results for \"{1}\"",
    'PeopleDirectory.XPeople': "{0} People",
    'PeopleDirectory.SearchUsers' : 'Search Users'
}  

const Profile = {
    "Profile.EditYourProfile": "Edit Your Profile",
    "Profile.JobRole": "Job Role",
    "Profile.Department": "Department",
    "Profile.FullSize" : "Full Size",
    "Profile.PhoneNumber": "Phone Number",
    "Profile.ProfileImage": "Profile Image",
    "Profile.MyProfile": "My Profile",
    "Profile.PersonalisedImage": "My Personalised Profile Icon",
    "Profile.Preferences": "Preferences",
    "Profile.AutoplayVideos": "Autoplay videos in lists",
    "Profile.AutoplayVideoExplainer": "Play videos silently as you scroll",
    "Profile.DefaultImage": "My Default Profile Icon",
    "Profile.EditProfile": "Edit Profile",
    "Profile.DisplayName": "Display Name",
    "Profile.UpdateSuccess": "Profile updated successfully.",
    "Profile.UpdateFail": "Profile could not be updated.",
    "Profile.DragPhoto": "Drag file here to change photo, or [underline]browse[/underline]",
    "Profile.DropAnImage" : "Drop an image here or click to browse",
    "Profile.AddPhoto": "Add Photo",
    "Profile.ChangePhoto": "Change Photo",
    "Profile.UserNameNotFound" : "Username not found",
    "Profile.NoUsernameDefaultImage" : "Username not found's Default Profile Icon",
    "Profile.UserDefaultImage": "{0}'s Default Profile Icon",
    "Profile.UserPersonalisedImage": "{0}'s Personalised Profile Icon",
    "Profile.ViewProfile" : "View Profile",
    "Profile.XProfileImage": "{0}'s Profile Image",
    "Profile.ViewMyProfile": "View my profile",
    "Profile.ViewFullSizeImage": "View my profile"
}

const Comments = {
    'Comments.CommentSingular': "{0} Comment",
    'Comments.LikeSingular':'{0} Like',
    'Comments.AddComment' : "Add a comment",
    'Comments.AddAComment':'Add a comment...',
    'Comments.AddACommentPlaceholder':'Add a comment...',
    'Comments.AreYouSureYouWantToRemoveThisComment':'Are you sure you want to remove this comment?',
    'Comments.BeTheFirstToComment':'Be the first to comment',
    'Comments.CannotLoadMoreReplies':'Cannot load more replies',
    'Comments.CannotLoadNextComments':'Cannot load next comments',
    'Comments.CannotLoadPreviousComments':'Cannot load previous comments',
    'Comments.Comment':'Comment',
    'Comments.CommentOnThisPost':'Comment on this post',
    'Comments.CommentRemoved':'This comment has been removed.',
    'Comments.Comments':'Comments',
    'Comments.FeedbackPlaceHolder':'Your comments',
    'Comments.SendFeedback':'Send Feedback',
    'Comments.YourFeedback':'Your Feedback',
    'Comments.CommentTooLong':'Comment too long',
    'Comments.DoYouWantToDiscardChangesToYourComment':'Do you want to discard changes to your comment?',
    'Comments.DoYouWantToDiscardYourComment':'Do you want to discard your comment?',
    'Comments.EditComment':'Edit Comment',
    'Comments.Edited':'edited',
    'Comments.EditReply':'Edit reply',
    'Comments.EditYourComment':'Edit your comment',
    'Comments.HideReplies':'Hide Replies',
    'Comments.Like':'Like',
    'Comments.Liked': 'Liked',
    'Comments.LikeThis':'Like this',
    'Comments.LimitReached' : 'Comment character limit reached',
    'Comments.LoadMoreComments':'Load more comments',
    'Comments.Newest':'Newest',
    'Comments.Oldest':'Oldest',
    'Comments.PleaseShortenYourCommentTo5000CharactersOrLess':'Please shorten your comment to 5000 characters or less',
    'Comments.PostComment': 'Post Comment',
    'Comments.RemoveComment':'Remove Comment',
    'Comments.RemoveThisComment':'Remove this comment?',
    'Comments.Reply':'Reply',
    'Comments.ReplyingTo':'Replying to',
    'Comments.ReplyToComment':'Reply to comment',
    'Comments.ReportAComment':'Report a Comment',
    'Comments.ReportComment':'Report Comment',
    'Comments.ReportedCommentsWillBeReviewedByAnAdministratorWhoWillTakeAction':'Reported comments will be reviewed by an administrator who will take action',
    'Comments.ReportExplanatory':'Reported comments will be reviewed by an administrator who will take action.',
    'Comments.ReportInputPlaceholder':'Tell us why you are reporting this comment',
    'Comments.ReportSuccessful':'Comment reported successfully.',
    'Comments.SaveComment' : 'Save Comment',
    'Comments.Sending':'Sending...',
    'Comments.SendReport':'Send Report',
    'Comments.ShowReplies':'Show Replies',
    'Comments.SortBy':'Sort by {0}',
    'Comments.TellUsWhyYouAreReportingTheComment':'Tell us why you are reporting the comment',
    'Comments.ThankYouForYourFeedback':'Thank you for your feedback',
    'Comments.ThisCommentHasBeenRemoved':'This comment has been removed',
    'Comments.ViewCommentOptions':'View comment options',
    'Comments.View1Reply':'View 1 reply',
    'Comments.ViewMoreReplies':'View more replies',
    'Comments.ViewNextComments':'View next comments',
    'Comments.ViewNextReplies':'View next replies',
    'Comments.ViewPreviousComments':'View previous comments',
    'Comments.ViewPreviousReplies':'View previous replies',
    'Comments.ViewXReplies':'View {0} replies',
    'Comments.WeWereUnableToSendYourReport':'We were unable to send your report',
    'Comments.WriteAComment':'Write a comment',
    'Comments.WriteAReply':'Write a reply',
    'Comments.XComments':'{0} Comments',
    'Comments.XLikes':'{0} Likes',

    /* New */
    'Comments.Loading': 'Loading...',
    'Comments.CommentUpdated': 'Comment updated',
    'Comments.CommentEditFailed': 'Comment edit failed',
    'Comments.CommentSaved': 'Comment saved',
    'Comments.CommentSaveFailed': 'Comment save failed',
    'Comments.CommentDeleteFailed': 'Comment deletion failed',
    'Comments.RemovedCommentUsernamePlaceholder': '[Removed]',
    'Comments.DiscardChanges': 'Discard Changes',
    'Comments.DiscardComment': 'Discard Comment',
    'Comments.DiscardTheseChanges': 'Discard these changes?',
    'Comments.DiscardThisComment': 'Discard this comment?'
}

const Notifications = {
    'Notifications.ANewCompetitionHasBeenPosted': "A new competition has been posted: ",
    'Notifications.ANewEventHasBeenPosted': "A new event has been posted: ",
    'Notifications.ANewPostRequiresYourAttention': "A new post requires your attention: ",
    'Notifications.AreYouSureYouWantToCall': "Are you sure you want to call: ",
    'Notifications.Go': "Go",
    'Notifications.GoFindSomeInterestingPostsAndAddYourThoughts': "Go find some interesting posts and add your thoughts!",
    'Notifications.Have': "{0} have {1} {2} {3}",
    'Notifications.LikedYourComment': " liked your comment: ",
    'Notifications.LoadMoreNotifications': "Load more notifications",
    'Notifications.MentionedInComment': "[strong]{0}[/strong] mentioned you in a comment: [strong]{1}[/strong]",
    'Notifications.MentionedYouInAComment': " mentioned you in a comment: ",
    'Notifications.NewCompetition': "A new competition has been posted: [strong]{0}[/strong]",
    'Notifications.NewEvent': "A new event has been posted: [strong]{0}[/strong]",
    'Notifications.NewPost': "A new post needs your attention: [strong]{0}[/strong]",
    'Notifications.NoNotifications': "No notifications",
    'Notifications.NoNotificationsFindSome': "No notifications yet, go find some interesting posts and add your thoughts!",
    'Notifications.OneLikedComment': "[strong]{0}[/strong] liked the comment: [strong]{1}[/strong]",
    'Notifications.OneRepliedToComment': "[strong]{0}[/strong] replied to the comment: [strong]{1}[/strong]",
    'Notifications.RepliedToYourComment': " replied to your comment: ",
    'Notifications.SignInCodeRequest' : "Sign-in code requested for your account.",
    'Notifications.ThisIsWhereYoullFindYourNotifications': "This is where you'll find your notifications",
    'Notifications.UgcNotification': "[strong]{0}[/strong] posted {1} to {2}",
    'Notifications.XLikedComment': "[strong]{0}[/strong] have liked the comment: [strong]{1}[/strong]",
    'Notifications.XRepliedToComments': "[strong]{0}[/strong] have replied to the comment: [strong]{1}[/strong] ",
    'Notifications.YouHaveBeenThankedBy': "You have been thanked by {0}!",
    'Notifications.YourNotifications': "Your Notifications",
    'Notifications.PasskeyResetRequested': `Account reset requested for {0}. Verification Required.`,
    'Notifications.PlannerEventCreated': 'Event {0} has been posted',
    'Notifications.PlannerEventCancelled': 'Event {0} has been cancelled',
    'Notifications.PlannerEventApproved': 'Your response to {0} has been approved',
    'Notifications.PlannerEventDeclined': 'Your response to {0} has been declined'
}

const errors = {
    'Errors.UnhandledError': 'An unexpected error has occurred. You cannot complete this action at this time.',
    'Errors.Oops': 'Oops!',
    "Errors.ABuildWithThisPackageNameAlreadyExists": "A build with this package name already exists.",
    "Errors.AccountInvalid": "This account is no longer valid.",
    "Errors.AccountLocked": "This account is currently locked, please try again later.",
    "Errors.AcknowledgementContentIsAtCapacity": "Acknowledgement content is at capacity",
    "Errors.AgreeToTerms" : "Agree to terms",
    "Errors.AlreadyRegistered": "User is already registered.",
    "Errors.AutomaticLoginError": "An Error occurred while attempting to automatically login.",
    "Errors.CannotConvert0IntoXamarinFormsEasing": "Cannot convert \\\\{0}\\\\ into Xamarin.Forms.Easing",
    "Errors.CannotUploadProfile": "Could not upload profile picture. The file format is not supported or the file is too large",
    "Errors.ClipboardError": "Something went wrong copying the link to the clipboard",
    "Errors.CommentDeleted": "Could not save comment. The comment has since been deleted.",
    "Errors.ContentTemporarilyUnavailable": "Sorry, this content is temporarily unavailable.",
    "Errors.ContentUnavailable": "This content is no longer available - please select a channel to continue.",
    "Errors.CouldntUpdateProfilePicture": "Couldn't update profile picture",
    "Errors.CountryCodeIsInvalid": "Country code is invalid",
    "Errors.EmailAddressIsInvalid": "Email address is invalid",
    "Errors.EmailAlreadyConfirmed": "Email Already Confirmed",
    "Errors.EmailAlreadyInUseAsRecoveryMethodByAnotherUser": "Email already in use as recovery method by another user",
    "Errors.Error": "Error",
    "Errors.ErrorFromServer": "Error from server:",
    "Errors.ErrorFromServerGone": "Error from server: Gone",
    "Errors.FailedToUpdatePassword": "Failed to update password.",
    "Errors.FormSaveError":"Form Save Error",
    "Errors.GenericError": "Sorry, an error has occurred",
    "Errors.InvalidCountryCode": "Invalid country code.",
    "Errors.InvalidCredentials": "Invalid Credentials",
    "Errors.InvalidModel": "Invalid Model",
    "Errors.InvalidUrl": "Invalid Url",
    "Errors.ItemKeyIsRequired": "itemKey is required",
    "Errors.NameTooLong": "Name too long.",
    "Errors.NewPasswordCannotBeTheSameAsTheOldOne": "New password cannot be the same as the old one.",
    "Errors.NoApps": "You have no apps.[break][/break] Please contact your company admin to gain access.",
    "Errors.NoContent": "No content accessible or no content existing - please contact your Administrator",
    'Errors.NoPermissionToOrgContent': "You don't have permission to access [strong]{0}[/strong]. You are currently logged into [strong]{1}[/strong].",
    "Errors.NoPermission": "You do not have permission to access this content - please select a channel to continue.",
    "Errors.NoVppCodesAreAvailable": "No VPP codes are available",
    "Errors.NoVppKeywordExists": "No VPP keyword exists",
    "Errors.NotModifiedWithEmptyCacheShouldntHappen": "Not modified with empty cache, shouldn't happen.",
    "Errors.OneTimePasswordExpired": "One-Time password is incorrect or expired.",
    "Errors.OneTimePasswordInvalid": "One-time password invalid. Please try again or request another.",
    "Errors.OrgDoesNotExist": "Organization [strong]{0}[/strong] does not exist. Please check the spelling and try again.",
    "Errors.PasswordDoesntMeetRequirements": "Password doesn't meet requirements.",
    "Errors.PersonDoesNotExist": "This user does not exist.",
    "Errors.PhoneNumberAlreadyAssociatedWithThisAccount": "Phone number already associated with this account",
    "Errors.PhoneNumberIsAlreadyInUse": "Phone number already registered.",
    "Errors.PhoneNumberIsInvalid": "Phone number is invalid.",
    "Errors.PhoneNumberNotConfirmed": "Phone number is not confirmed yet.",
    "Errors.PleaseTryAgain":"Please try again.",
    "Errors.ProfileCouldNotBeLoaded": "Profile could not be loaded.",
    "Errors.RecoveryMethodNotSetupForThisUser": "Recovery method not setup for this user",
    "Errors.RegisterPhone": "An error occurred while registering phone number.",
    "Errors.RegisterUserDetailsError": "An error occurred while registering user details.",
    "Errors.RegisteringError": "An error occurred while registering.",
    "Errors.RegisteringPasswordError": "An error occured while registering password.",
    "Errors.RequestUri": "Request URI: ",
    "Errors.RequiresEmailDomainValidation": "Requires Email Domain Validation",
    "Errors.SomethingHasGoneWrong": "Something has gone wrong",
    "Errors.SorryGoogleLoginUnsupportedAtThisTime": "Sorry - Google login unsupported at this time.",
    "Errors.SorryThisPageHasBeenRemovedAndCannotBeDisplayedPleaseSelectADifferentPageFromTheMenu": "Sorry, this page has been removed and cannot be displayed. Please select a different page from the menu.",
    "Errors.SorryUnableToLogInAtThisTime": "Sorry - unable to log in at this time",
    "Errors.SorryUnableToUpdateCommentsLikesAtThisTime": "Sorry - unable to update Comments/Likes at this time",
    "Errors.SorryWeWereUnableToUpdateYourPassword": "Sorry, we were unable to update your password.",
    "Errors.ThisContentIsNotAvailableOfflinePleaseConnectAgainAndRetry": "This content is not available offline.{0}Please connect again and retry.",
    "Errors.ThisPageIsNotCurrentlyAvailablePleaseTryAgainLaterIfTheProblemPersistsPleaseContactYourAppAdministrator": "This page is not currently available, please try again later. If the problem persists please contact your app administrator.",
    "Errors.ThisUserIsNoLongerAvailableInYourOrganization": "This user is no longer available in your organization",
    "Errors.Timeout": "Your request timed out.",
    "Errors.UnableToResetPassword": "Unable to reset password.",
    "Errors.UnableToUpdateProfileAtThisTime": "Unable to update profile at this time.",
    "Errors.Unauthorised": "You are not authorized to view this content or your session has expired. Please login again.",
    "Errors.UnknownBuild": "Unknown Build",
    "Errors.UnknownDataErr": "Unknown data item type",
    "Errors.UnknownEmailDomain": "Unknown Email Domain",
    "Errors.UnknownType": "Unknown Type",
    "Errors.UnknownUser": "Unknown User",
    "Errors.UserInactive": "User Inactive",
    "Errors.UserIsAlreadyRegistered": "User is already registered",
    "Errors.UserIsNotInThisOrganisation": "User is not in this organisation",
    "Errors.UserLockedOut": "User Locked Out",
    "Errors.UserLockedOutUntil": "This user is locked out until {0}.",
    "Errors.UserNoLongerInOrg": "This user is no longer available in your organisation",
    "Errors.UserNotOnboarded": "User not onboarded",
    "Errors.ValidationCodeIsInvalid": "Validation code is invalid",
    "Errors.ValidationErrors": "One or more validation details were invalid.",
    "Errors.Failed":"Failed",
    "Errors.ErrorVerifyingCode": "There was an error verifying your code",
    "Errors.LockOutMessage" : "Too many failed login attempts. Please try again in: {0}.",
    "Errors.FormNotValid": "Please fill in the required fields and try again",
    "Errors.MaxFileCountReached": "Maximum file limit reached. {0}/{0} files added",
    "Errors.CannotPlayVideo":"We're unable to play the video due to unsupported file type or its unavailability. You can try downloading it using the provided link. If that fails, please try again later or contact an administrator."
}

const Passkeys = {
    'Passkeys.EditPasskey' : "Edit Passkey",
	'Passkeys.LastUsed' : "Last used",
	'Passkeys.RemovePasskey': "Remove Passkey",
	'Passkeys.CreatePasskey' : "Create Passkey",
    'Passkeys.CodeAccepted' : "Code Submitted",
    'Passkeys.CodeInvalid' : "The code couldn’t be verified. Check that it’s correct and try again.",
	'Passkeys.ManagePasskeys': "Manage Passkeys",
	'Passkeys.PasskeySettings' : "Passkey Settings",
	'Passkeys.SignIn' : "Sign in to another device",
	'Passkeys.SignInPrompt': "On the device you are trying to sign in on, click ‘Get sign in code’ to get a code, then enter it here to finish signing in.",
	'Passkeys.RemovePasskeyPrompt' : "This passkey will no longer work for signing in. If this is your only passkey, you’ll lose access to your account.",
	'Passkeys.ShowIPAddress' : "Show IP Address",
	'Passkeys.SignInCodeRequested': "Sign-in code requested for your account.",
	'Passkeys.ContinuePrompt' : "Only continue if this was you.",
	'Passkeys.AccountReset': "Account Reset",
	'Passkeys.ResetRequested' : "Account reset requested for {0}.",
	'Passkeys.RecoveryRequest' : "Account Recovery Request for {0}.",
	'Passkeys.RecoveryRequestPrompt' : "A recovery request was submitted for {0}’s account. Before approving, confirm that the request genuinely came from the account owner. All recovery actions must be completed in the CMS.",
	'Passkeys.RemovePasskeyLogOut' : "Removing this passkey will log you out of your current session. Are you sure you want to delete this passkey?",
    'Passkeys.Verification' : "Verification Required.",
    'Passkeys.VerifyCode' : "Verify Code",
    "Passkeys.EmptyState": "Create your first passkey, or sign out and sign back in with an existing passkey."
}

const Planner = {
    'General.Planner': 'Planner',
    'General.CreatedBy': 'Created by {0}',
    'Planner.AwaitingYourResponse': 'Awaiting Your Response',
    'Planner.UpcomingEvents': 'Upcoming Events',
    'Planner.Repeats': 'Repeats {0} from  {1} - {2}',
    'Planner.AreYouAttending': 'Are you attending?',
    'Planner.EventRequiresMoreInfo': 'This event requires you to fill in some additional information.',
    'Planner.ThisEventRequiresAdminApproval': 'This event requires administrator approval. You will recieve a notification to approve or deny your request.',
    'Planner.AddToCalendar': 'Add to Calendar',
    'Planner.EditResponse': 'Edit Response',
    'Planner.Responded': 'Responded: ',
    'Planner.RespondedConcat': 'Responded: {0}',
    'Planner.Confirmed': 'Confirmed: ',
    'Planner.ConfirmedConcat': 'Confirmed: {0}',
    'Planner.NoUpcomingEvents': 'You have no upcoming events. Events you are invited to will appear here and in your notifications centre.',
    'Planner.ViewDetails': 'View Details',
    'Planner.ViewAll': 'View All',
    "Planner.ResponseReceived": "Response Received",
    "Planner.YouAreNowAttending": "You are now attending this event",
    "Planner.YouAreNotAttending": "You are not attending this event",
    "Planner.RSVPAttending": "I am attending",
    "Planner.RSVPNotAttending": "Not attending",
    "Planner.ViewDiscarded": "View Discarded",
    "Planner.BackToPlanner": "Back to Planner",
    "Planner.ViewDiscardedEvents": "View Discarded Events",
    "Planner.AwaitingResponse": "Awaiting Response",
    "Planner.Attending": "Attending",
    "Planner.NotAttending": "Not Attending",
    "Planner.BackToAll" : "Back to all",
    "Planner.CustomTimeExplanatory": "This event accepts a custom time response. Please ensure this is accurate.",
    "Planner.Cancelled": "Cancelled",
    "Planner.AlreadyAttending": "Already Responded",
    "Planner.EventFull": "Event Full", 
    "Planner.CannotChangeResponse": "Already Responded",
    "Planner.Unknown": "Unknown",
    "Planner.CannotChangeResponseLong": "This event does not allow responses to be changed",
    "Planner.EventFullSpacesLong": "This event is now full",
    "Planner.EventFullTimeLong": "This event has a limit of {0} hours left",
    "Planner.AlreadyAttendingLong": "You have already responded to this event",
    "Planner.CancelledLong": "This event has been cancelled",
    "Planner.EventStarted": "Event Started",
    "Planner.EventStartedLong": "You are no longer able to attend this event as it is already in progress.",
    "Planner.EventFinished": "Event Finished",
    "Planner.EventFinishedLong": "You are no longer able to attend this event as it has already finished.",
    "Planner.DiscardedEvents": "Discarded Events",
    "Planner.SelectedTime":"Selected time: {0}",
    "Planner.TotalTime":"Total Shift: {0}",
    "Planner.Gone": "This event has been removed by an administrator",
    "Planner.Ended": "Ended",
    "Planner.PendingApprovalLong": "Thank you for your response. You will be notified if your request has been approved or declined.",
    "Planner.PendingApproval": "Pending Approval",
    "Planner.EventClosed": "Event Closed",
    "Planner.EventClosedLong": "This event has been closed by the organiser and is no longer accepting responses."
}

const Errors = {
    'Errors.UnhandledError': 'An unexpected error has occurred. You cannot complete this action at this time.',
    'Errors.Oops': 'Oops!',
    'Errors.CannotPlayInBrowser': 'Cannot play video in this browser.',
    'Errors.FileTypeMayNotBeSupported': 'This is a {0} file and may not be supported by all web browsers. If the video cannot be played, it will be available for download',
    'Errors.RecommendedVideoTypes': 'Recommended video file types: .mp4 .webm .ogg'
}

const Search = {
    'Search.SearchPlaceHolderConcat': 'Search for any content across \"{0}\"',
    'Search.SearchPlaceHolder': 'Search for any content across',
    'Seach.AllTime': 'All Time',
    'Search.Last7Days': 'Last 7 Days',
    'Search.Last30Days': 'Last 30 Days',
    'Search.Last6Months': 'Last 6 Months',
    'Search.ThisYear': 'Past Year',
    'Search.LastYear': 'Last Year',
    'Search.ImagesOnly': 'Images Only',
    'Search.VideosOnly': 'Videos Only',
    'Search.FilesOnly': 'Files Only',
    'Search.AudioOnly': 'Audio Only',
    'Search.WebOnly': 'Web Only' ,
    'Search.FeaturedImageForX': 'Featured Image for {0}',
    'Search.FoundIn': 'Found in' ,
    'Search.FoundInConcat': 'Found in {0}',
    'Search.Published': 'Published',
    'Search.PublishedConcat': 'Published {0}',
    'Search.Languages': 'Languages',
    'Search.Type': 'Type',
    'Search.ContentType': 'Content Type',
    'Search.Results':  'results',
    'Search.ResultsConcat': '{0} results',
    'Search.OneResult': '1 result',
    'Search.Default': '(Default)',
    'Search.AppDefault': '(App default)',
    'Search.Rules': 'Rules',
    'Search.SearchTitlesOnly': 'Search Titles Only',
    'Search.NoResultsFound': 'No results found',
    'Search.FoundInPlacesConcat': 'Found in {0} places',
    'Search.TitleMatch': 'Title Match'
}

const Countries = {
    "Countries.AC": "Ascension Island",
    "Countries.AD": "Andorra",
    "Countries.AE": "United Arab Emirates",
    "Countries.AF": "Afghanistan",
    "Countries.AG": "Antigua & Barbuda",
    "Countries.AI": "Anguilla",
    "Countries.AL": "Albania",
    "Countries.AM": "Armenia",
    "Countries.AO": "Angola",
    "Countries.AR": "Argentina",
    "Countries.AS": "American Samoa",
    "Countries.AT": "Austria",
    "Countries.AU": "Australia",
    "Countries.AW": "Aruba",
    "Countries.AX": "Åland Islands",
    "Countries.AZ": "Azerbaijan",
    "Countries.BA": "Bosnia & Herzegovina",
    "Countries.BB": "Barbados",
    "Countries.BD": "Bangladesh",
    "Countries.BE": "Belgium",
    "Countries.BF": "Burkina Faso",
    "Countries.BG": "Bulgaria",
    "Countries.BH": "Bahrain",
    "Countries.BI": "Burundi",
    "Countries.BJ": "Benin",
    "Countries.BL": "Saint Barthélemy",
    "Countries.BM": "Bermuda",
    "Countries.BN": "Brunei",
    "Countries.BO": "Bolivia",
    "Countries.BQ": "Caribbean Netherlands",
    "Countries.BR": "Brazil",
    "Countries.BS": "Bahamas",
    "Countries.BT": "Bhutan",
    "Countries.BW": "Botswana",
    "Countries.BY": "Belarus",
    "Countries.BZ": "Belize",
    "Countries.CA": "Canada",
    "Countries.CC": "Cocos (Keeling) Islands",
    "Countries.CD": "Congo - Kinshasa",
    "Countries.CF": "Central African Republic",
    "Countries.CG": "Congo - Brazzaville",
    "Countries.CH": "Switzerland",
    "Countries.CI": "Côte d'Ivoire",
    "Countries.CK": "Cook Islands",
    "Countries.CL": "Chile",
    "Countries.CM": "Cameroon",
    "Countries.CN": "China",
    "Countries.CO": "Colombia",
    "Countries.CR": "Costa Rica",
    "Countries.CU": "Cuba",
    "Countries.CV": "Cape Verde",
    "Countries.CW": "Curaçao",
    "Countries.CX": "Christmas Island",
    "Countries.CY": "Cyprus",
    "Countries.CZ": "Czechia",
    "Countries.DE": "Germany",
    "Countries.DJ": "Djibouti",
    "Countries.DK": "Denmark",
    "Countries.DM": "Dominica",
    "Countries.DO": "Dominican Republic",
    "Countries.DZ": "Algeria",
    "Countries.EC": "Ecuador",
    "Countries.EE": "Estonia",
    "Countries.EG": "Egypt",
    "Countries.EH": "Western Sahara",
    "Countries.ER": "Eritrea",
    "Countries.ES": "Spain",
    "Countries.ET": "Ethiopia",
    "Countries.FI": "Finland",
    "Countries.FJ": "Fiji",
    "Countries.FK": "Falkland Islands",
    "Countries.FM": "Micronesia",
    "Countries.FO": "Faroe Islands",
    "Countries.FR": "France",
    "Countries.GA": "Gabon",
    "Countries.GB": "United Kingdom",
    "Countries.GD": "Grenada",
    "Countries.GE": "Georgia",
    "Countries.GF": "French Guiana",
    "Countries.GG": "Guernsey",
    "Countries.GH": "Ghana",
    "Countries.GI": "Gibraltar",
    "Countries.GL": "Greenland",
    "Countries.GM": "Gambia",
    "Countries.GN": "Guinea",
    "Countries.GP": "Guadeloupe",
    "Countries.GQ": "Equatorial Guinea",
    "Countries.GR": "Greece",
    "Countries.GT": "Guatemala",
    "Countries.GU": "Guam",
    "Countries.GW": "Guinea-Bissau",
    "Countries.GY": "Guyana",
    "Countries.HK": "Hong Kong",
    "Countries.HN": "Honduras",
    "Countries.HR": "Croatia",
    "Countries.HT": "Haiti",
    "Countries.HU": "Hungary",
    "Countries.ID": "Indonesia",
    "Countries.IE": "Ireland",
    "Countries.IL": "Israel",
    "Countries.IM": "Isle of Man",
    "Countries.IN": "India",
    "Countries.IO": "British Indian Ocean Territory",
    "Countries.IQ": "Iraq",
    "Countries.IR": "Iran",
    "Countries.IS": "Iceland",
    "Countries.IT": "Italy",
    "Countries.JE": "Jersey",
    "Countries.JM": "Jamaica",
    "Countries.JO": "Jordan",
    "Countries.JP": "Japan",
    "Countries.KE": "Kenya",
    "Countries.KG": "Kyrgyzstan",
    "Countries.KH": "Cambodia",
    "Countries.KI": "Kiribati",
    "Countries.KM": "Comoros",
    "Countries.KN": "Saint Kitts & Nevis",
    "Countries.KP": "North Korea",
    "Countries.KR": "South Korea",
    "Countries.KW": "Kuwait",
    "Countries.KY": "Cayman Islands",
    "Countries.KZ": "Kazakhstan",
    "Countries.LA": "Laos",
    "Countries.LB": "Lebanon",
    "Countries.LC": "Saint Lucia",
    "Countries.LI": "Liechtenstein",
    "Countries.LK": "Sri Lanka",
    "Countries.LR": "Liberia",
    "Countries.LS": "Lesotho",
    "Countries.LT": "Lithuania",
    "Countries.LU": "Luxembourg",
    "Countries.LV": "Latvia",
    "Countries.LY": "Libya",
    "Countries.MA": "Morocco",
    "Countries.MC": "Monaco",
    "Countries.MD": "Moldova",
    "Countries.ME": "Montenegro",
    "Countries.MF": "Saint Martin",
    "Countries.MG": "Madagascar",
    "Countries.MH": "Marshall Islands",
    "Countries.MK": "North Macedonia",
    "Countries.ML": "Mali",
    "Countries.MM": "Myanmar",
    "Countries.MN": "Mongolia",
    "Countries.MO": "Macau",
    "Countries.MP": "Northern Mariana Islands",
    "Countries.MQ": "Martinique",
    "Countries.MR": "Mauritania",
    "Countries.MS": "Montserrat",
    "Countries.MT": "Malta",
    "Countries.MU": "Mauritius",
    "Countries.MV": "Maldives",
    "Countries.MW": "Malawi",
    "Countries.MX": "Mexico",
    "Countries.MY": "Malaysia",
    "Countries.MZ": "Mozambique",
    "Countries.NA": "Namibia",
    "Countries.NC": "New Caledonia",
    "Countries.NE": "Niger",
    "Countries.NF": "Norfolk Island",
    "Countries.NG": "Nigeria",
    "Countries.NI": "Nicaragua",
    "Countries.NL": "Netherlands",
    "Countries.NO": "Norway",
    "Countries.NP": "Nepal",
    "Countries.NR": "Nauru",
    "Countries.NU": "Niue",
    "Countries.NZ": "New Zealand",
    "Countries.OM": "Oman",
    "Countries.PA": "Panama",
    "Countries.PE": "Peru",
    "Countries.PF": "French Polynesia",
    "Countries.PG": "Papua New Guinea",
    "Countries.PH": "Philippines",
    "Countries.PK": "Pakistan",
    "Countries.PL": "Poland",
    "Countries.PM": "Saint Pierre & Miquelon",
    "Countries.PR": "Puerto Rico",
    "Countries.PS": "Palestine",
    "Countries.PT": "Portugal",
    "Countries.PW": "Palau",
    "Countries.PY": "Paraguay",
    "Countries.QA": "Qatar",
    "Countries.RE": "Réunion",
    "Countries.RO": "Romania",
    "Countries.RS": "Serbia",
    "Countries.RU": "Russia",
    "Countries.RW": "Rwanda",
    "Countries.SA": "Saudi Arabia",
    "Countries.SB": "Solomon Islands",
    "Countries.SC": "Seychelles",
    "Countries.SD": "Sudan",
    "Countries.SE": "Sweden",
    "Countries.SG": "Singapore",
    "Countries.SH": "Saint Helena",
    "Countries.SI": "Slovenia",
    "Countries.SJ": "Svalbard & Jan Mayen",
    "Countries.SK": "Slovakia",
    "Countries.SL": "Sierra Leone",
    "Countries.SM": "San Marino",
    "Countries.SN": "Senegal",
    "Countries.SO": "Somalia",
    "Countries.SR": "Suriname",
    "Countries.SS": "South Sudan",
    "Countries.ST": "São Tomé & Príncipe",
    "Countries.SV": "El Salvador",
    "Countries.SX": "Sint Maarten",
    "Countries.SY": "Syria",
    "Countries.SZ": "Eswatini",
    "Countries.TA": "Tristan da Cunha",
    "Countries.TC": "Turks & Caicos Islands",
    "Countries.TD": "Chad",
    "Countries.TG": "Togo",
    "Countries.TH": "Thailand",
    "Countries.TJ": "Tajikistan",
    "Countries.TK": "Tokelau",
    "Countries.TL": "Timor-Leste",
    "Countries.TM": "Turkmenistan",
    "Countries.TN": "Tunisia",
    "Countries.TO": "Tonga",
    "Countries.TR": "Türkiye",
    "Countries.TT": "Trinidad & Tobago",
    "Countries.TV": "Tuvalu",
    "Countries.TW": "Taiwan",
    "Countries.TZ": "Tanzania",
    "Countries.UA": "Ukraine",
    "Countries.UG": "Uganda",
    "Countries.US": "United States",
    "Countries.UY": "Uruguay",
    "Countries.UZ": "Uzbekistan",
    "Countries.VA": "Vatican City",
    "Countries.VC": "Saint Vincent & the Grenadines",
    "Countries.VE": "Venezuela",
    "Countries.VG": "British Virgin Islands",
    "Countries.VI": "U.S. Virgin Islands",
    "Countries.VN": "Vietnam",
    "Countries.VU": "Vanuatu",
    "Countries.WF": "Wallis & Futuna",
    "Countries.WS": "Samoa",
    "Countries.XK": "Kosovo",
    "Countries.YE": "Yemen",
    "Countries.YT": "Mayotte",
    "Countries.ZA": "South Africa",
    "Countries.ZM": "Zambia",
    "Countries.ZW": "Zimbabwe"
}
const Sections = {
    "Sections.Chat": "Chat"
}

const Chat = {
    "Chat.NoConversations": "No conversations yet. Start one now!",
    "Chat.NewChat": "New Chat",
    "Chat.WriteAMessage": "Write a message",
    "Chat.SendMessage": "Send message",
    "Chat.YourMessageCouldNotBeDelivered": "Your message could not be delivered.",
    "Chat.SelectAConversationOrStartANewChat": "Select a conversation or start a new chat.",
    "Chat.YouConcat": "You: {0}"
}

export const defaultLocalisation = {
    'emptyString': '',
    ...file,
    ...General,
    ...Locker,
    ...People,
    ...Onboarding,
    ...Month,
    ...date,
    ...Profile,
    ...Comments,
    ...Notifications,
    ...Passkeys,
    ...Planner,
    ...errors,
    ...Search,
    ...Errors,
    ...Countries,
    ...Sections,
    ...Chat
}
